import { render, staticRenderFns } from "./file_browser.vue.js?vue&type=template&id=4825dcbe&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./file_browser.vue?vue&type=template&id=4825dcbe&vue3"
import script from "./file_browser.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./file_browser.vue?vue&type=script&lang=js&vue3"
export * from "./file_browser.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./file_browser.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports